// #region Imports

import Vue from 'vue';
import IoConfirmDialog from '@/components/confirm-dialog';
import MaintenanceBanner from '@/components/MaintenanceBanner';
import BannerManager from '@/components/BannerManager';
// Already statically imported elsewhere — keep registration sync to avoid Vite chunk warnings.
import IoAlerts from '@/components/IoAlerts.vue';
import IoDataTable from '@/components/IoDataTable.vue';

// #endregion

// #region Component Registration

Vue.use(IoConfirmDialog);
Vue.component('MaintenanceBanner', MaintenanceBanner);
Vue.component('BannerManager', BannerManager);
Vue.component('BrandImagesEdit', () => import(/* webpackChunkName: "legacy-components" */ '@/base/settings/brands/BrandImagesEdit.vue'));
Vue.component('DynamicComponentList', () => import(/* webpackChunkName: "legacy-components" */ '@/components/DynamicComponentList.vue'));
Vue.component('IoAlerts', IoAlerts);
Vue.component('IoBreadcrumbs', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoBreadcrumbs.vue'));
Vue.component('IoBtnInfo', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoBtnInfo.vue'));
Vue.component('IoCard', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoCard.vue'));
Vue.component('IoCardTabs', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoCardTabs.vue'));
Vue.component('IoConfirmForm', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoConfirmForm.vue'));
Vue.component('IoConfirmLink', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoConfirmLink.vue'));
Vue.component('IoDataTable', IoDataTable);
Vue.component('IoDatePicker', () => import(/* webpackChunkName: "legacy-components" */ '@/components/forms/IoDatePicker.vue'));
Vue.component('IoInboxMenuItem', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoInboxMenuItem.vue'));
Vue.component('IoOptionsButton', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoOptionsButton.vue'));
Vue.component('IoOverlay', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoOverlay.vue'));
Vue.component('BaseProgress', () => import(/* webpackChunkName: "legacy-components" */ '@/components/BaseProgress.vue'));
Vue.component('IoSearchForm', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoSearchForm.vue'));
Vue.component('IoTabsContainer', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoTabsContainer.vue'));
Vue.component('IoTenantSwitch', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoTenantSwitch.vue'));
Vue.component('IoTransitionExpand', () => import(/* webpackChunkName: "legacy-components" */ '@/components/IoTransitionExpand.vue'));
Vue.component('Settings', () => import(/* webpackChunkName: "legacy-components" */ '@/components/settings/Settings.vue'));
Vue.component('SettingsV2', () => import(/* webpackChunkName: "legacy-components" */ '@/components/settings/SettingsV2.vue'));
Vue.component('AddOnsPortalSetup', () => import(/* webpackChunkName: "base-pages" */ '@/components/AddOnsPortalSetup.vue'));
Vue.component('TabsCard', () => import(/* webpackChunkName: "legacy-components" */ '@/components/TabsCard.vue'));
Vue.component('IoPasswordChecker', () => import(/* webpackChunkName: "base-pages" */ '@/components/IoPasswordChecker.vue'));

// #endregion
